import { render, staticRenderFns } from "./advAuthRole.vue?vue&type=template&id=15d31729&scoped=true&"
import script from "./advAuthRole.vue?vue&type=script&lang=js&"
export * from "./advAuthRole.vue?vue&type=script&lang=js&"
import style0 from "./advAuthRole.vue?vue&type=style&index=0&id=15d31729&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d31729",
  null
  
)

export default component.exports